export type Capability =
  | 'view.manifests'
  | 'approve.manifest'
  | 'reject.manifest'
  | 'patch.manifest'
  | 'manage.read_post_allowlist'
  | 'view.credentials'
  | 'rotate.credential'
  | 'delete.credential'
  | 'view.admin_users'
  | 'create.admin_user'
  | 'delete.admin_user'
  | 'reset.admin_user_password';

const ADMIN_CAPS: readonly Capability[] = [
  'view.manifests',
  'approve.manifest',
  'reject.manifest',
  'patch.manifest',
  'manage.read_post_allowlist',
  'view.credentials',
  'rotate.credential',
  'delete.credential',
  'view.admin_users',
  'create.admin_user',
  'delete.admin_user',
  'reset.admin_user_password',
];

export function capabilitiesFor(role: 'admin' | 'user' | null | undefined): readonly Capability[] {
  if (role === 'admin') return ADMIN_CAPS;
  return [];
}
